/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2016-2018, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

/**
 * A directive modifies an element already annotated with the medium editor clone to also use the
 * medium-editor-insert-plugin.
 *
 * A few other modifications to make the editor work nicely within bulb have been added as well.
 */
angular.module('bulbApp.contentEditorModule')

.directive('contentBlock', ['BulbCommentService', contentBlock]);

function contentBlock(BulbCommentService) {
  return {
    require: ['^bulbPageView', 'contentBlock'],
    restrict: 'E',
    scope: {},
    controller: 'ContentBlockController as contentBlockCtrl',
    link: function link(scope, elem, attr, ctrls) {

      scope.pageViewCtrl = ctrls[0];
      scope.commentService = BulbCommentService;
      var contentBlockCtrl = ctrls[1];

      contentBlockCtrl.page = scope.pageViewCtrl.page;
      contentBlockCtrl.contentBlock = contentBlockCtrl.page.unit.contentBlocks[attr.id];
      contentBlockCtrl.contentBlockElement = elem;
    },
    templateUrl: 'ajs/components/contenteditor/contentblock.html'
  };
}
